<template>
    <div>
        <div class="column justify-center items-center q-mb-md" id="printable">
            <qrcode :value="getUrl" :options="{ width: 300 }" tag="img"></qrcode>
            <p>{{ $t('code') }}: {{ qrcode_formated_code }}  </p>
        </div>

        <div class="row gutter-sm justify-center">
            <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'events' })" />
            </div>

            <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                <q-btn color="secondary"  @click="print()" class="full-width" :label="$t('print')" icon="far fa-print"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import { colors } from 'quasar'

export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'admin', 'events'] },

    components: { 'qrcode':  VueQrcode},

    data(){
        return {
            id_event: '',
            qrcode_url: '',
            qrcode_formated_code: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getUrl() {
            return `${process.env.API_URL}${this.qrcode_url}`
        },
    },

    methods: {
        fetchData() {
            this.$q.loading.show()
            this.$axios.get(`/admin_rewards/events_qrcode/${this.id_event}/qrcode/`, this.getHeader)
            .then(response => {
                this.qrcode_url = response.data.qrcode_url
                this.qrcode_formated_code = response.data.qrcode_formated_code
                this.$q.loading.hide()
            })
            .catch(erro => console.log(erro))
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        print() {
            var elQrcode = document.querySelector("#printable").innerHTML
            var html =
            `
            <html>
                <head></head>
                    <style>
                        body {
                            height: 100vh;
                        }
                        .printable {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            height: 100vh;
                        }
                        .box {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            color: #000;
                            padding: 25px;
                            border-radius: 10px;
                            height: auto;
                            width: 40vw;
                            text-align: center;
                        }
                        p{
                            font-size: 25px;
                            word-wrap: break-word;
                        }
                    </style>
                    <body>
                        <div class="printable">
                            <div class="printable box">
                                ${elQrcode}
                            </div>
                        </div>
                    </body>
            </html>
            `
            let win = window.open()
            win.document.open().write(html)
            win.print();
        }
    },
    created() {
        this.id_event = this.$route.params.id
        if( this.id_event) this.fetchData()

    }
}
</script>

<style lang="stylus">
.none
    display none

</style>